// Text helpers for community news. Kept out of the News component so they can
// be unit-tested without pulling in react-markdown (ESM-only under Jest).

// Strip Markdown down to a short plain-text excerpt for the compact home
// preview. Not a full parser — it removes the common inline/block syntax so a
// teaser reads as prose, then truncates on a word boundary. The full article
// (with real Markdown rendering) still lives one click away on /news. Mirrors
// the sanitizing approach used for event descriptions (see eventText.js).
export function excerptText(md, maxLen = 220) {
  if (!md) return '';
  const text = md
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')        // images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')       // links -> link text
    .replace(/`{1,3}([^`]*)`{1,3}/g, '$1')         // inline code / fences
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')            // ATX headings
    .replace(/^\s{0,3}>\s?/gm, '')                 // blockquotes
    .replace(/^\s{0,3}(?:[-*+]|\d+\.)\s+/gm, '')   // list markers
    .replace(/^\s{0,3}(?:-{3,}|\*{3,}|_{3,})\s*$/gm, ' ') // horizontal rules
    .replace(/[*_~]/g, '')                         // emphasis markers
    .replace(/\s+/g, ' ')                          // collapse whitespace
    .trim();
  if (text.length <= maxLen) return text;
  const cut = text.slice(0, maxLen);
  const lastSpace = cut.lastIndexOf(' ');
  const trimmed = lastSpace > maxLen * 0.6 ? cut.slice(0, lastSpace) : cut;
  return `${trimmed.trimEnd()}…`;
}
